import React, { Dispatch, SetStateAction, useState } from 'react';
import ListCheckBox from '../ListCheckBox';

const InputSearchRadio = ({
  options,
  selectedItem,
  setSelectedItem,
  selectedValue,
}: {
  options: any;
  selectedItem: any;
  selectedValue: any;
  setSelectedItem: Dispatch<SetStateAction<any>>;
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="w-full mx-auto">
      {/* Input Search */}
      <div className="mb-4 relative">
        <span className="absolute inset-y-0 left-3 flex items-center text-gray-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
            />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Cari model mobil"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full border p-2 rounded pl-10"
        />
      </div>

      <ListCheckBox
        searchTerm={searchTerm}
        items={options}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        selectedValue={selectedValue}
      />
    </div>
  );
};

export default InputSearchRadio;
